module.exports = __webpack_public_path__ + "img/tick.2f94e15e.svg";